import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormArrayTableComponent } from 'src/app/components/common/form-array-table/form-array-table.component';
import { ValidatedCurrencyInputComponent } from '../../../common/validated-currency-input/validated-currency-input.component';
import { IncomeTable } from '../knowledge-test.models';

@Component({
  selector: 'app-income-table',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormArrayTableComponent,
    ValidatedCurrencyInputComponent,
  ],
  templateUrl: './income-table.component.html',
  styleUrl: './income-table.component.scss',
})
export class IncomeTableComponent {
  formControls = input.required<FormArray<FormGroup<IncomeTable>>>();
  currencyCode = input.required<string>();
  canAdd = input(false);
  createNewFileGroup = output<void>();
  onFormSubmit(event: Event): void {
    event.preventDefault();
  }
  onEnterKey(event: Event): void {
    event.preventDefault();
  }
}
